<div class="flex flex-col">
  <h1 mat-dialog-title>Confirm Delete</h1>
  <div mat-dialog-content>
    <p>Are you sure you want to delete this item?</p>
  </div>
  <div mat-dialog-actions class="flex justify-end">
    <button mat-button (click)="onNoClick()">No</button>
    <button mat-button color="warn" (click)="onYesClick()">Yes</button>
  </div>
</div>

